import React, { useState } from "react";
import { useTransactionFlow } from "@/context/TransactionContext";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { ButtonSize, RegularButton } from "@/stories/button/button";
import { AlertCircle } from "lucide-react";
import LoadingIcon from "@/app/assets/icons/loading";
import useMobile from "@/app/hooks/use-mobile";

interface PaymentStepProps {
    onComplete: () => void;
    restartFlow: () => void;
    isAdvisoryFlow?: boolean;
}

const ErrorModal: React.FC<PaymentStepProps> = ({ onComplete, restartFlow, isAdvisoryFlow }) => {
    const { state } = useTransactionFlow();
    const { isMobile } = useMobile();

    const [isRestarted, setisRestarted] = useState<boolean>(false);

    const handleError = () => {
        setisRestarted(true);
        restartFlow();
    };

    return (
        <Dialog open={true} onOpenChange={onComplete}>
            <DialogContent className="w-[90%] !rounded-3xl p-9 md:w-[460px]">
                <VisuallyHidden.Root>
                    <DialogTitle>Error Modal</DialogTitle>
                </VisuallyHidden.Root>
                <div className="w-full">
                    <div className="flex w-full">
                        <AlertCircle className="m-auto h-8 w-8 text-red-500" />
                    </div>
                    <div className="w-full text-center text-xl font-semibold">
                        <div className="flex flex-col items-center justify-center py-3">
                            Something went wrong
                        </div>
                    </div>
                    <div className="flex-center flex flex-col items-center">
                        <p className="w-full text-center text-md">
                            {state.error || "An error occurred. Please try again later."}
                        </p>
                    </div>
                </div>
                {!isAdvisoryFlow && <RegularButton
                    className="md:mt-8 max-w-full text-lg"
                    size={isMobile ? ButtonSize.Small : ButtonSize.Large} 
                    label={!isRestarted ? "Retry" : ""}
                    disabled={isRestarted}
                    icon={isRestarted ? <LoadingIcon className="animate-sping" /> : <></>}
                    noIcon={!isRestarted}
                    showRightIcon={false}
                    onClick={handleError}
                />}
            </DialogContent>
        </Dialog>
    );
};

export default ErrorModal;
